import { createSectionTitle, createSummaryTitle, createTable, parseHtmlContent } from '../utils';

export const renderAllergies = (data, title) => {
  const content = [];

  content.push(createSectionTitle(title));

  // Handle noDetails case
  if (data && data.noDetails) {
    content.push({
      text: 'No details',
      style: 'narrative',
      margin: [0, 0, 0, 8]
    });
    return content;
  }

  // Helper function to check if allergy data is meaningful
  const hasValidAllergies = (allergies) => {
    if (!allergies || !Array.isArray(allergies) || allergies.length === 0) return false;
    return allergies.some((item) => {
      return (
        item.allergy?.label ||
        item.allergy?.value ||
        (item.reaction && item.reaction.trim() !== '') ||
        (item.associatedMedication && item.associatedMedication.trim() !== '') ||
        (item.typicalReaction?.label && item.typicalReaction.label.trim() !== '') ||
        (item.typicalReaction?.value && item.typicalReaction.value.trim() !== '') ||
        (item.medication?.label && item.medication.label.trim() !== '') ||
        (item.medication?.value && item.medication.value.trim() !== '') ||
        (item.note && item.note.trim() !== '')
      );
    });
  };

  // Check if there's any meaningful data to display
  const hasRows = hasValidAllergies(data.allergies);
  const hasNarrative = data && data.narrative && data.narrative.trim() !== '';

  // If no meaningful data and no narrative, show "No data"
  if (!hasRows && !hasNarrative) {
    content.push({
      text: 'No data',
      style: 'narrative',
      margin: [0, 0, 0, 8]
    });
    return content;
  }

  if (hasRows) {
    const headers = ['Allergy', 'Reaction', 'Associated medication'];
    const rows = data.allergies
      .filter((item) => {
        // Filter out empty rows
        const hasAllergy = item.allergy?.label || item.allergy?.value;
        const hasReaction =
          (item.reaction && item.reaction.trim() !== '') ||
          (item.typicalReaction?.label && item.typicalReaction.label.trim() !== '') ||
          (item.typicalReaction?.value && item.typicalReaction.value.trim() !== '');
        const hasMedication =
          (item.associatedMedication && item.associatedMedication.trim() !== '') ||
          (item.medication?.label && item.medication.label.trim() !== '') ||
          (item.medication?.value && item.medication.value.trim() !== '');
        const hasNote = item.note && item.note.trim() !== '';
        return hasAllergy || hasReaction || hasMedication || hasNote;
      })
      .map((item) => {
        const allergyName = item.allergy?.label || item.allergy?.value || 'Unknown allergy';

        // Handle multiple possible field names for reaction
        const reactionText =
          item.reaction || item.typicalReaction?.label || item.typicalReaction?.value || '';

        // Handle multiple possible field names for medication
        const medicationText =
          item.associatedMedication || item.medication?.label || item.medication?.value || '';

        return [
          { text: allergyName || '-', style: 'tableCell' },
          { text: reactionText || '-', style: 'tableCell' },
          { text: medicationText || '-', style: 'tableCell' }
        ];
      });

    if (rows.length > 0) {
      content.push(createTable(headers, rows, ['33%', '33%', '34%']));
    }
  }

  // Show narrative if it exists
  if (hasNarrative) {
    content.push(createSummaryTitle());
    content.push({
      text: parseHtmlContent(data.narrative),
      style: 'narrative',
      margin: [0, 0, 0, 8]
    });
  }

  // If no content was added beyond title, show "No data"
  if (content.length === 1) {
    content.push({
      text: 'No data',
      style: 'narrative',
      margin: [0, 0, 0, 8]
    });
  }

  return content;
};
